import {createAction} from "@reduxjs/toolkit";

const auth_state = createAction("AUTH_STATE");
const cognito_user = createAction("COGNITO_USER");
const realvr_user = createAction("REALVR_USER");

export {
  auth_state,
  cognito_user,
  realvr_user,
}